const backendUrl =
  process.env.NEXT_PUBLIC_API_URL ??
  "http://localhost:3000";

export type CurrentUserResponse = {
  user: {
    id: number;
    privyUserId: string;
    email: string;
    walletAddress: string;
    platformRole: string;
  };
  memberships: Array<{
    agreement_id: number;
    user_id: number;
    agreement_role: string;
  }>;
};

export async function backendFetch(
  path: string,
  accessToken: string
) {
  return fetch(
    `${backendUrl}${path}`,
    {
      cache: "no-store",
      headers: {
        Authorization:
          `Bearer ${accessToken}`
      }
    }
  );
}

export async function getCurrentUser(
  accessToken: string
) {
  const response =
    await backendFetch(
      "/api/auth/me",
      accessToken
    );

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error(
        "Authentication session token unverified (401). Please try signing in again with your registered email."
      );
    }
    if (response.status === 403) {
      throw new Error(
        "Account not found for this email address (403). Please contact your administrator to assign your account."
      );
    }
    throw new Error(
      `Unable to load account (${response.status}).`
    );
  }

  return await response.json() as CurrentUserResponse;
}
